// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2kF6s","header":"Messages_header__2b_Oa"};